import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  Input,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { DashboardItem } from './dashboard-item';
import { OnDashboardItemDataChanges } from './on-dashboard-item-data-changes';

@Component({
  selector: 'labs-dashboard-item',
  template: '<ng-template #vcr></ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardItemComponent implements AfterViewInit {
  @ViewChild('vcr', { read: ViewContainerRef }) vcr: ViewContainerRef;

  @Input() item: DashboardItem;

  private componentRef: ComponentRef<OnDashboardItemDataChanges>;

  constructor(
    private cd: ChangeDetectorRef,
    private resolver: ComponentFactoryResolver
  ) {}

  ngAfterViewInit() {
    if (this.item) {
      const factory = this.resolver.resolveComponentFactory(
        this.item.component
      );
      this.componentRef = this.vcr.createComponent<OnDashboardItemDataChanges>(
        factory
      );
      this.componentRef.instance.onDashboardItemDataChanges(this.item.data);
      this.cd.markForCheck();
    }
  }
}
